import { application } from "./application"
import AutoSubmitController from "./auto_submit_controller"
import CalculatorController from "./calculator_controller"
import ModalResetController from "./modal_reset_controller"
import SearchClearController from "./search_clear_controller"
import SortTableController from "./sort_table_controller"
import StickyNudgeController from "./sticky_nudge_controller"
import CookieConsentController from "./cookie_consent_controller"

application.register("auto-submit", AutoSubmitController)
application.register("calculator", CalculatorController)
application.register("cookie-consent", CookieConsentController)
application.register("modal-reset", ModalResetController)
application.register("search-clear", SearchClearController)
application.register("sort-table", SortTableController)
application.register("sticky-nudge", StickyNudgeController)

application.debug = true
